module.exports = __webpack_public_path__ + "media/images/pages/sample_images/sample-fashion-7220409c15e2b97ebea8772ba3155274.jpeg";